import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subject } from 'rxjs';
import { TickerBlock } from 'src/app/content-blocks/models/ticker-block';

@Component({
  selector: 'app-ticker-block',
  templateUrl: './ticker-block.component.html',
  styleUrls: ['./ticker-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TickerBlockComponent implements OnInit, OnDestroy {
  @Input()
  tickerBlock: TickerBlock;

  ngUnsubscribe = new Subject();

  constructor() {}

  ngOnInit(): void {}

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
